export default class CaptureImage {
    constructor() {
        this.width = 400; // We will scale the photo width to this
        this.height = 0; // This will be computed based on the input stream
        this.streaming = false;

        this.video = null;
        this.canvas = null;
        this.photo = null;
        this.startbutton = null;
    }

    showViewLiveResultButton() {
        if (window.self !== window.top) {
            document.querySelector(".contentarea").remove();
            const button = document.createElement("button");
            button.textContent = "View live result of the example code above";
            document.body.append(button);
            button.addEventListener("click", () => window.open(location.href));
            return true;
        }
        return false;
    }

    startup() {
        if (this.showViewLiveResultButton()) {
            return;
        }
        this.video = document.getElementById("video");
        this.canvas = document.getElementById("canvas");
        this.photo = document.getElementById("photo");
        this.startbutton = document.getElementById("captureButton");

        navigator.mediaDevices
            .getUserMedia({ video: true, audio: false })
            .then((stream) => {
                this.video.srcObject = stream;
                this.video.play();
            })
            .catch((err) => {
                console.error(`An error occurred: ${err}`);
            });

        this.video.addEventListener(
            "canplay",
            (ev) => {
                if (!this.streaming) {
                    this.height = this.video.videoHeight / (this.video.videoWidth / this.width);

                    if (isNaN(this.height)) {
                        this.height = this.width / (4 / 3);
                    }

                    this.video.setAttribute("width", this.width);
                    this.video.setAttribute("height", this.height);
                    this.canvas.setAttribute("width", this.width);
                    this.canvas.setAttribute("height", this.height);
                    this.streaming = true;
                }
            },
            false,
        );

        this.startbutton.addEventListener(
            "click",
            (ev) => {
                this.takepicture();
                ev.preventDefault();
            },
            false,
        );

        this.clearphoto();
    }

    clearphoto() {
        const context = this.canvas.getContext("2d");
        context.fillStyle = "#AAA";
        context.fillRect(0, 0, this.canvas.width, this.canvas.height);

        const data = this.canvas.toDataURL("image/png");
        this.photo.setAttribute("src", data);
        document.getElementById('imageSrc').value = "";
    }

    takepicture() {
        const context = this.canvas.getContext("2d");
        if (this.width && this.height) {
            this.canvas.width = this.width;
            this.canvas.height = this.height;
            context.drawImage(this.video, 0, 0, this.width, this.height);

            const data = this.canvas.toDataURL("image/png");
            this.photo.setAttribute("src", data);
            this.video.style.display = "none";
            this.canvas.style.display = "none";
            this.photo.style.display = "block";
            document.getElementById('imageSrc').value = data;
        } else {
            this.clearphoto();
        }
    }
}